
export default function formatMission (goal) {
  if(goal.generalGoal !== undefined) {
    return goal.generalGoal
  } else {
    let allGoalsTogether = [];
      if(goal.steps) allGoalsTogether.push(`dê ${goal.steps} passos`)
      if(goal.caloriesOut) allGoalsTogether.push(`gaste ${goal.caloriesOut} calorias`)
      if(goal.activeMinutes) allGoalsTogether.push(`fique ${goal.activeMinutes} minutos ativos`)
      if(goal.wakeMinutes) allGoalsTogether.push(`tenha no máximo ${goal.wakeMinutes} minutos sem sono`)
      if(goal.remMinutes) allGoalsTogether.push(`tenha ${goal.remMinutes} minutos de sono REM`)
      if(goal.lightMinutes) allGoalsTogether.push(`tenha ${goal.lightMinutes} minutos de sono leve`)
      if(goal.deepMinutes) allGoalsTogether.push(`tenha ${goal.deepMinutes} sono profundo`)
      if(goal.awakeMinutes) allGoalsTogether.push(`tenha ${goal.awakeMinutes} minutos acordado`)

      const stringGoal = allGoalsTogether.join(', ');
      
      const upperCaseStringGoal = stringGoal.charAt(0).toUpperCase() + stringGoal.slice(1)
      return upperCaseStringGoal;
  }
}